// QuotationsInProgress.jsx
import { useNavigate } from "react-router-dom";
import quotationsData from "../../../data/quotationsData";

function money(n) {
  return `₹${n.toLocaleString("en-IN")}`;
}

const statusStyles = {
  Draft: "bg-gray-100 text-gray-600",
  Published: "bg-blue-50 text-blue-700",
  "Quotations Received": "bg-indigo-50 text-indigo-700",
  "Under Evaluation": "bg-amber-50 text-amber-700",
  "Quotation Selected": "bg-emerald-50 text-emerald-700",
  "Work Order Initiated": "bg-emerald-50 text-emerald-700",
  "In Development": "bg-emerald-50 text-emerald-700",
  Completed: "bg-gray-100 text-gray-600",
};

const IN_PROGRESS_STATUSES = [
  "Quotations Received", 
  "Under Evaluation", 
  "Quotation Selected", 
  "Work Order Initiated", 
  "In Development"
];

export default function QuotationsInProgress() {
  const navigate = useNavigate();

  const inProgressQuotations = quotationsData.filter((q) =>
    IN_PROGRESS_STATUSES.includes(q.status)
  );

  const quotationsReceived = inProgressQuotations.filter(
    (q) => q.status === "Quotations Received"
  ).length;
  const underEvaluation = inProgressQuotations.filter(
    (q) => q.status === "Under Evaluation"
  ).length;
  const selected = inProgressQuotations.filter(
    (q) => q.status === "Quotation Selected"
  ).length;
  const activeProjects = inProgressQuotations.filter((q) =>
    ["Work Order Initiated", "In Development"].includes(q.status)
  ).length;

  const stats = [
    { label: "Quotations Received", value: quotationsReceived },
    { label: "Under Evaluation", value: underEvaluation },
    { label: "Selected", value: selected },
    { label: "Active Projects", value: activeProjects },
  ];

  return (
    <div>
      {/* Summary stats */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
        {stats.map((s) => (
          <div
            key={s.label}
            className="bg-white border border-gray-100 rounded-2xl p-3"
          >
            <p className="text-xs font-semibold text-gray-400 tracking-wide">
              {s.label.toUpperCase()}
            </p>
            <p className="text-2xl font-extrabold text-gray-900">{s.value}</p>
          </div>
        ))}
      </div>

      {/* Table - No Actions column */}
      <div className="bg-white border border-gray-100 rounded-2xl overflow-auto mb-8">
        <table className="w-full text-sm">
          <thead style={{backgroundColor:"#f9fbfe"}}>
            <tr className="border-b border-gray-100 text-left text-xs font-semibold text-gray-400 tracking-wide">
              <th className="px-5 py-3">Enquiry</th>
              <th className="px-5 py-3">Category</th>
              <th className="px-5 py-3">Budget</th>
              <th className="px-5 py-3">Target</th>
              <th className="px-5 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {inProgressQuotations.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-5 py-10 text-center text-gray-400">
                  No in-progress projects. All your projects have been completed.
                </td>
              </tr>
            ) : (
              inProgressQuotations.map((q) => (
                <tr
                  key={q.id}
                  className="border-b border-gray-50 last:border-0 hover:bg-gray-50/60 transition"
                >
                  <td className="px-5 py-4" style={{ whiteSpace:"nowrap"}}>
                    <p className="font-semibold text-gray-900">{q.title}</p>
                    <p className="text-xs text-gray-400">{q.id}</p>
                  </td>
                  <td className="px-5 py-4 text-gray-600">{q.category}</td>
                  <td className="px-5 py-4 text-gray-600 whitespace-nowrap">
                    {money(q.budgetMin)} – {money(q.budgetMax)}
                  </td>
                  <td className="px-5 py-4 text-gray-600 whitespace-nowrap">
                    {q.targetDate}
                  </td>
                 
                  <td className="px-5 py-4">
                    <span
                      className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${
                        statusStyles[q.status] || "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {q.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}